import directives from './directives';

const importDirective = (Vue) => {
  Vue.directive('permission', directives.permission);
};

export default importDirective;
